import { dropoffProviderType } from "@redotech/redo-return-dropoff-provider-common/dropoff-provider";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const boxlessDropoffFee = z.object({
  provider: z.enum(dropoffProviderType),
  /** Stored per-team fee; undefined means the provider's default applies. */
  fee: z.number().optional(),
  /** Whether this provider is configurable for the team (e.g. FedEx Easy Returns needs an integration). */
  available: z.boolean(),
});

export const getBoxlessDropoffFees = unaryRpc({
  name: "getBoxlessDropoffFees" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ fees: z.array(boxlessDropoffFee) }),
});

export const updateBoxlessDropoffFee = unaryRpc({
  name: "updateBoxlessDropoffFee" as const,
  input: z.object({
    teamId: z.string(),
    provider: z.enum(dropoffProviderType),
    fee: z.number().min(0),
  }),
  output: boxlessDropoffFee,
});
